export const version = "sha2/5.6.0";
//# sourceMappingURL=_version.js.map